import React from 'react'

import { Bold, Box, Display, Heading2, JustifyContent, Space } from '@gousto-internal/citrus-react'
import { BenefitItem, LandingPageButton, LargeImageWithText } from '../../../../components'
import dinner from '../../../../sections/assets/dinner.jpg'
import dinnerDesktop from '../../../../sections/assets/dinnerDesktop.jpg'
import type { HowGoustoFoodBoxesWorkTypes } from '../../../../types'
import { MealPlanningSections, TargetUri, TrackingActions } from '../../../../types/tracking'
import { WHY_GOUSTO } from './config'

export function WhyChooseGoustoSection({ startOnboarding }: HowGoustoFoodBoxesWorkTypes) {
  return (
    <LargeImageWithText altText={WHY_GOUSTO.altText} desktopSrc={dinnerDesktop} mobileSrc={dinner}>
      <Heading2>Why choose Gousto for your weekly meals</Heading2>
      <Space size={3} />
      <BenefitItem title="Keep it flexible">
        Gousto will never lock you into a meal planning subscription.{' '}
        <Bold>You can pause, switch delivery days or cancel whenever you like.</Bold> So if
        you&apos;re away or know you&apos;ve got a busy social calendar that week, you won&apos;t
        feel like anything is going to waste.
      </BenefitItem>
      <BenefitItem title="Massive selection">
        There are over 175 recipes on our menu every week, with{' '}
        <Bold> something for every palate and every dietary need</Bold> (veggie, flexi, low cal,
        high protein - you want it, we&apos;ve got it). Once you&apos;ve picked how many Gousto
        meals you fancy each week, it&apos;s time for the fun bit - choosing what to eat. Whether
        you&apos;re feeding <Bold>picky eaters, flavour fanatics or just yourself,</Bold> our
        menu&apos;s got you covered. Meal planning made marvellous.
      </BenefitItem>
      <BenefitItem title="Make life easier">
        Let&apos;s be real - meal planning isn&apos;t just for ultra-organised spreadsheet people.
        It&apos;s for anyone who eats food. Busy bees, big families, small families, solo diners,
        snackers with a budget, or folks just trying to get their life (and dinner) together.{' '}
        <Bold> Get everything you need for the week</Bold> in one food box and{' '}
        <Bold>enjoy faster meals, more variety and leftovers that actually get eaten. </Bold>
      </BenefitItem>
      <BenefitItem title="No food waste">
        Here it is: the food waste-busting tip to rule them all - meal planning. When you plan your
        meals with Gousto, you could{' '}
        <Bold>reduce your weekly carbon emissions by a whopping 23%.</Bold> With precise,
        pre-measured ingredients for every recipe, you&apos;ll have a head start in your fight to
        reduce food waste.
      </BenefitItem>
      <Space size={4} />
      <Box
        display={Display.Flex}
        justifyContent={[JustifyContent.Center, JustifyContent.FlexStart]}
      >
        <LandingPageButton
          startOnboarding={startOnboarding}
          sectionName={MealPlanningSections.WHY_CHOOSE_GOUSTO}
          target={TargetUri.SIGNUP}
          action={TrackingActions.CLICK_GET_STARTED}
        >
          {WHY_GOUSTO.ctaText}
        </LandingPageButton>
      </Box>
    </LargeImageWithText>
  )
}
